import React, { PropTypes } from 'react';
import ReactSparkSelectInput from '../../../widgets/ReactSparkSelectInput';
import { getStatusValue, getParentStatusValue, getStatusOptions } from './utils';

function Status({ parentValue, level, isDisabled, value, objectName, setValue }) {
    const statusValue = getStatusValue(value, level);
    const parentStatusValue = getParentStatusValue(parentValue, level);
    const options = getStatusOptions(parentStatusValue, level);

    return (
        <div>
            <h5 className="no-text-transform">Select appropriate status for this app</h5>
            <div className="section-content col-md-12">
                <ReactSparkSelectInput
                    label="Status"
                    isDisabled={isDisabled}
                    defaultValue={statusValue}
                    values={options}
                    onChange={event => setValue(`${objectName}.status`, event.target.value)}
                />
            </div>
        </div>
    );
}

Status.propTypes = {
    isDisabled: PropTypes.bool,
    value: PropTypes.string,
    parentValue: PropTypes.string,
    objectName: PropTypes.string,
    setValue: PropTypes.func
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/StatusComponent.js